import React from "react";
import { useSelector } from "react-redux";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CloseIcon from "../../../Common/Svgs/CloseIcon";

const ViewLicenseModal = ({ visible, onCancel }) => {
  const { licenseModal } = useSelector((state) => state.users);

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="586px">
      <div
        className="rounded-xl overflow-hidden"
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="flex items-center justify-between pl-4 pt-4 pb-6 pr-6">
          <div className="flex items-center gap-x-3">
            <div className="w-12 h-12 bg-primary flex items-center justify-center rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="#FAFAFA"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeMiterlimit="10"
                  strokeWidth="1.5"
                  d="M2 8.505h20M6 16.505h2M10.5 16.505h4"
                />
                <path
                  stroke="#FAFAFA"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M6.44 3.505h11.11c3.56 0 4.45.88 4.45 4.39v8.21c0 3.51-.89 4.39-4.44 4.39H6.44c-3.55.01-4.44-.87-4.44-4.38v-8.22c0-3.51.89-4.39 4.44-4.39"
                />
              </svg>
            </div>

            <p className="font-poppins text-base font-medium">
              {licenseModal?.type === "driver"
                ? "Driver’s License"
                : "Partner ID"}
            </p>
          </div>

          <button type="button" className="mr-2" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className="bg-light-grey flex items-center justify-center p-4">
          <div className="w-full h-[302px]">
            {licenseModal?.url ? (
              <img
                src={licenseModal?.url}
                className="w-full h-full object-contain"
                alt="id"
              />
            ) : (
              <p className="py-[130px] sfont-poppins font-medium text-sm text-center">
                Preview Unavailable
              </p>
            )}
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default ViewLicenseModal;
